import { Avatar, Box, IconButton, Typography } from "@mui/material";
import { DeleteIconList, EditIcon } from "@platformx/shared/static-assets";
import { ErrorTooltip, useAccess } from "@platformx/utilities";
import { useNavigate } from "react-router-dom";
import { USER_PERMISSIONS } from "../../helper/helper";
import SkeletonCard from "./SkeletonCard";
import TopHeader from "./TopHeader/TopHeader";
import { useCustomStyle } from "./UserRoleListCard.style";

const UserRoleListCard = ({ userRoleList, loading }) => {
  const classes = useCustomStyle();
  const { canAccessAction } = useAccess();
  const navigate = useNavigate();
  const { category, subCategory, update } = USER_PERMISSIONS;

  return (
    <Box className={`${classes.userListRowWrapper} userListRowWrapperInner`}>
      <TopHeader />
      {loading ? (
        <SkeletonCard />
      ) : (
        userRoleList.map((item) => (
          <Box className='userListRowItem' key={item._id}>
            <Avatar src='/broken-image.jpg' variant='rounded' sx={{ marginRight: "20px" }} />
            <Box sx={{ flex: 1 }}>
              <Typography variant='p3semibold'>{item?.name}</Typography>
              <Typography variant='p4regular' className='textDescription'>
                {item?.description}
              </Typography>
            </Box>
            <Box sx={{ display: "flex" }}>
              <Box className='assignee'>
                <Typography variant='p3regular'>Assignee</Typography>
                <Typography variant='h5semibold'>{item?.userCount}</Typography>
              </Box>
              <Box sx={{ paddingLeft: "20px" }}>
                <ErrorTooltip
                  component={
                    <IconButton
                      data-testid='edit'
                      className='hoverIcon'
                      onClick={() => navigate("/user-management/permission-assignatation")}
                      disabled={!canAccessAction(category, subCategory, update)}>
                      <img src={EditIcon} alt='Edit Icon' />
                    </IconButton>
                  }
                  doAccess={!canAccessAction(category, subCategory, update)}
                />
                <IconButton
                  data-testid='edit'
                  className='hoverIcon'
                  disabled={true}
                  sx={{ opacity: 0.5, cursor: "not-allowed" }}>
                  <img src={DeleteIconList} alt='Delete' />
                </IconButton>
              </Box>
            </Box>
          </Box>
        ))
      )}
      {userRoleList.length === 0 && !loading && (
        <Box className='noDataFound'>
          <Typography variant='p3regular'>No data found</Typography>
        </Box>
      )}
    </Box>
  );
};

export default UserRoleListCard;
